const mobilenav = {
  init() {

    var openButton = document.querySelector('[data-behavior~=open-nav]');
    var closeButton = document.querySelector('[data-behavior~=close-nav]');

    openButton.addEventListener('click', function(el) {
      el.preventDefault();
      document.querySelector('[data-behavior~=mobile-nav]').style.height = "100%";
    })

    closeButton.addEventListener('click', function(el) {
      el.preventDefault();
      document.querySelector('[data-behavior~=mobile-nav]').style.height = "0%";
    })
  }
};

export default mobilenav;
